import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { PRESENT_RESET_ANSWER_Z_INDEX } from './activity-builder-present.constants';

export const ActivityPresentAnswerButtonContainer = styled.div``;

export const ActivityPresentAnswerButtonWrapper = styled.div`
  bottom: -${rem(25)};
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  z-index: ${PRESENT_RESET_ANSWER_Z_INDEX};

  ${mediaUp.md`
    left: auto;
  `}
`;
